export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('openForm');
    },
    closeForm({commit}) {
        commit('closeForm');
    }
}
